import { defineStore } from 'pinia';
import {readJSON} from '../utils/fetch.js'; 
import { toPng } from 'html-to-image'
import idb from '../utils/idb';


//narava icons
import icon80 from '@/assets/categories-icons/narava.svg';
import icon84 from '@/assets/categories-icons/narava-voda.svg';
import icon85 from '@/assets/categories-icons/narava-gozd.svg';
import icon86 from '@/assets/categories-icons/narava-zeleno.svg';
import icon104 from '@/assets/categories-icons/narava-gore.svg';
//sport icons
import icon81 from '@/assets/categories-icons/sport.svg';
import icon87 from '@/assets/categories-icons/sport-kolo.svg';
import icon88 from '@/assets/categories-icons/sport-pohodnistvo.svg';
import icon89 from '@/assets/categories-icons/sport-ostale.svg';
import icon99 from '@/assets/categories-icons/sport-druzinske-aktivnosti.svg';
//kultura icons
import icon82 from '@/assets/categories-icons/kultura.svg';
import icon90 from '@/assets/categories-icons/kultura-kulturne-ustanove.svg';
import icon91 from '@/assets/categories-icons/kultura-spomeniki.svg';
import icon92 from '@/assets/categories-icons/kultura-prireditve.svg';
import icon98 from '@/assets/categories-icons/kultura-sakralni-objekti.svg';
import icon100 from '@/assets/categories-icons/kultura-zgodovinske-ustanove.svg';
//turizem icons
import icon83 from '@/assets/categories-icons/turizem.svg';
import icon93 from '@/assets/categories-icons/turizem-hrana.svg';
import icon94 from '@/assets/categories-icons/turizem-prenocisce.svg';
import icon95 from '@/assets/categories-icons/turizem-zabava.svg';
import icon101 from '@/assets/categories-icons/turizem-trgovina.svg';
import icon102 from '@/assets/categories-icons/turizem-info-tocka.svg';
import icon103 from '@/assets/categories-icons/turizem-ostalo.svg';

//poi categories markers
import marker8084 from '@/assets/categories-markers/80-84.png';
import marker8085 from '@/assets/categories-markers/80-85.png';
import marker8086 from '@/assets/categories-markers/80-85.png';
import marker80104 from '@/assets/categories-markers/80-104.png';
import marker8187 from '@/assets/categories-markers/81-87.png';
import marker8188 from '@/assets/categories-markers/81-88.png';
import marker8189 from '@/assets/categories-markers/81-89.png';
import marker8199 from '@/assets/categories-markers/81-99.png';
import marker8290 from '@/assets/categories-markers/82-90.png';
import marker8291 from '@/assets/categories-markers/82-91.png';
import marker8292 from '@/assets/categories-markers/82-92.png';
import marker8298 from '@/assets/categories-markers/82-98.png';
import marker82100 from '@/assets/categories-markers/82-100.png';
import marker82103 from '@/assets/categories-markers/82-103.png';
import marker8393 from '@/assets/categories-markers/83-93.png';
import marker8394 from '@/assets/categories-markers/83-94.png';
import marker8395 from '@/assets/categories-markers/83-95.png';
import marker83101 from '@/assets/categories-markers/83-101.png';
import marker83102 from '@/assets/categories-markers/83-102.png';
import emptyMarker from '@/assets/categories-markers/empty-marker.png';
import currentLocation from '@/assets/current-location-icon.png';

export const useItineraryStore = defineStore('itineraryStore', {
    state: () => ({
        map: '',
        selectedPathNumber: 0,
        allPathsNumber: 0,
        selectedPath: '',
        currentDestination: '',
        urlParameterPath: '',
        itinerary: {} as any,
        allKeys: [] as any,
        dataVersion: '1', // data structure changes, increment this number
        dataUrl: import.meta.env.VITE_DATA_URL,
        poiServiceUrl: import.meta.env.VITE_DATA_POISERVICE,
        selectors: null,
        poiCategories: new Map(),
        categoryHierarchy: new Map(),
        categoryMarkersLook: new Map() as Map<string, string>,
        countCategoriesMarkers: 0,
        categoriesMarkersDone: false,
        showCamera : false,
        googlemapsDirectionsLink:'',
        options:null,
        markersImages: new Map(),
        blockNavigation: false,
        expressionMarkerPart: [] as any,
        selectedLanguage: 'sl',
        allLanguages:[],
        showNavigation: true,
        travelMode: 'walking',
        type: 'list',

        //drejc 
        activePoiProperties: null,
        activePoi: null,
        activeDestination: null,
        goaway: false
    }),
    actions: {
        setItinerary() {
          console.log('setItinerary')
            let _this = this;
            let parameter = window.location.search.substring(1);
            console.log("--------spura   startamo nalaganje vsebine glede na url")
            if(localStorage.getItem("simpl-pwa-app-data-version") != null) {
                let version = localStorage.getItem("simpl-pwa-app-data-version");
                if(version != this.dataVersion) {
                    this.rewriteData();
                }
            }else {
                localStorage.setItem("simpl-pwa-app-data-version", this.dataVersion);
            }

            if(parameter.length > 0) {
              // drug url za posamezni poi
              let jsonUrl = this.dataUrl + parameter + '.json';
              if(parameter.substring(0,3) == 'poi'){
                jsonUrl = this.poiServiceUrl + '?' + parameter ;
              }  

            
                readJSON(jsonUrl,function (result:any){
                    if(result == undefined){
                      console.log("result is undefined");
                      _this.IfNewData(false,parameter);
                      console.log("--------spura   prebrali json FAIL")
                      if(!_this.setActiveSet(parameter)) _this.checkIfSomethingToShow();
                      
                    }else {
                      let resultObject = JSON.parse(result);
                      _this.IfNewData(resultObject,parameter);
                      console.log("--------spura   prebrali json SUCCESS")    
                    }
                  });
            }else {
                _this.IfNewData(false,parameter);
                _this.checkIfSomethingToShow();
            }

        },
        checkIfSomethingToShow(){
          if(this.allKeys.length > 0){
            this.setActiveSetByIndex(this.allKeys.length-1)
          }
        },

        setActiveSetByIndex(index: any){
          if(this.allKeys.length > index){
            return this.setActiveSet(this.allKeys[index])
          }
          return false
        },   
        setActiveSet(name: any) {
            if (this.itinerary[name] == undefined) { 
                console.log("--------spura  provali smo aktivirat set ki ga ni v itinerariyju")
                return false;
            }
            const index = this.allKeys.indexOf(name);
            if(index == -1) {
                console.log("--------spura ERROR  provali smo aktivirat set, a sen slakada allkey in ittinerary ")
                return false;
            }
            this.selectedPath = name;
            this.selectedPathNumber = index;

            // Load destination options for language settings asynchronously
            const destinationId = this.itinerary[name].options?.destination;
            if (destinationId) {
                this.loadDestinationOptions(destinationId).catch(error => {
                    console.error('Error loading destination options:', error);
                });
            }

            return true;  
        },
        IfNewData(newData:any,key:string) {
            //check if there is data
            if (localStorage.getItem("simpl-pwa-app-data") != null) {
                //there is old data
                let oldData:any = JSON.parse(localStorage.getItem("simpl-pwa-app-data") as string);
                if(newData != false) {
                    //has new data
                    for (const [oldkey] of Object.entries(oldData)) {
                        oldkey == key ? delete oldData[oldkey] : null;
                    }
                    this.itinerary  = {[key]: newData ,...oldData};
                    localStorage.setItem("simpl-pwa-app-data", JSON.stringify(this.itinerary));
                }else {
                    //no new data
                    this.itinerary = oldData;
                }
                /*localStorage.setItem("simpl-pwa-app-data", JSON.stringify({[key]: newItinerary ,...oldData}));*/

            }else {
                //no old data
                newData != false ? this.itinerary = {[key]: newData} : this.itinerary = {};
                if(newData != false) {
                    localStorage.setItem("simpl-pwa-app-data", JSON.stringify({[key]: newData}));
                }
            }
        },
        rewriteData() {
            if (localStorage.getItem("simpl-pwa-app-data") != null) {
                let parameter = window.location.search.substring(1);
                let oldData:any = JSON.parse(localStorage.getItem("simpl-pwa-app-data") as string);
                let newItinerary:any = {};
                for (const [key] of Object.entries(oldData)) {
                    readJSON(this.dataUrl + parameter + '.json',function (result:any){
                        if(result == undefined){
                            console.log("result is undefined");
                        }else {
                            let resultObject = JSON.parse(result);
                            newItinerary = {[key]: resultObject ,...newItinerary};
                            localStorage.setItem("simpl-pwa-app-data", JSON.stringify(newItinerary));
                        }
                    });
                }
            }
        },
        async setCategories() {
            let selectorsCategories:any = this.selectors;
            if (selectorsCategories != null) {
                const categoryIcons = {
                  '80': icon80,
                  '84': icon84,
                  '85': icon85,
                  '86': icon86,
                  '104': icon104,
                  '81': icon81,
                  '87': icon87,
                  '88': icon88,
                  '89': icon89,
                  '99': icon99,
                  '82': icon82,
                  '90': icon90,
                  '91': icon91,
                  '92': icon92,
                  '98': icon98,
                  '100': icon100,
                  '83': icon83,
                  '93': icon93,
                  '94': icon94,
                  '95': icon95,
                  '101': icon101,
                  '102': icon102,
                  '103':icon103
                };

                this.markersImages.set('80-84',marker8084);
                this.markersImages.set('80-85',marker8085);
                this.markersImages.set('80-86',marker8086);
                this.markersImages.set('80-104',marker80104);
                this.markersImages.set('81-87',marker8187);
                this.markersImages.set('81-88',marker8188);
                this.markersImages.set('81-89',marker8189);
                this.markersImages.set('81-99',marker8199);
                this.markersImages.set('82-90',marker8290);
                this.markersImages.set('82-91',marker8291);
                this.markersImages.set('82-92',marker8292);
                this.markersImages.set('82-98',marker8298);
                this.markersImages.set('82-100',marker82100);
                this.markersImages.set('82-103',marker82103);
                this.markersImages.set('83-93',marker8393);
                this.markersImages.set('83-94',marker8394);
                this.markersImages.set('83-95',marker8395);
                this.markersImages.set('83-101',marker83101);
                this.markersImages.set('83-102',marker83102);
                this.markersImages.set('83-103',marker83102);
                this.markersImages.set('empty-marker',emptyMarker);
                this.markersImages.set('current-location',currentLocation);
                console.log("končano setCategories");
                useItineraryStore().expressionMarkerPart = [];

                for (let [key] of useItineraryStore().markersImages) {
                  let categories = key.split('-');
               
                  this.expressionMarkerPart.push([
                    'all',
                    ['==', ['at', 0, ['get', 'categories']], categories[0]],
                    ['==', ['at', 1, ['get', 'categories']], categories[1]],
                  ], `image-marker-${key}`);
                }
                
                Object.values(selectorsCategories.categories).forEach((category: any) => {
                  let isParent = false;
                  let color = '';

                  if(category.parent == '0') {
                    isParent = true;
                  }

                  switch(category.id) {
                    case '80':
                    case '84':
                    case '85':
                    case '86':
                    case '104':
                      color = '--nature-color';
                      break;
                    case '81':
                    case '87':
                    case '88':
                    case '89':
                    case '99':
                      color = '--sport-color';
                      break;
                    case '82':
                    case '90':
                    case '91':
                    case '92':
                    case '98':
                    case '100':
                    case '103':
                      color = '--culture-color';
                      break;
                    case '83':
                    case '93':
                    case '94':
                    case '95':
                    case '101':
                    case '102':
                      color = '--turism-color';
                      break;
                  }

                  this.poiCategories.set(category.id, {
                    name: category.name,
                    isParent: isParent,
                    parentId: category.parent,
                    cssColor: color,
                    className: category.id + '-subcategories',
                    number: 0,
                    icon: categoryIcons[category.id as keyof typeof categoryIcons] ?? icon80
                  });
                });
                this.countCategoriesMarkers = this.countCategoriesMarkers++;
              }

              console.log("selectorsCategories",selectorsCategories);
              if(selectorsCategories != undefined) {
                selectorsCategories.categories.forEach((category: { id: string, parent: string }) => {
                  if (category.parent !== "0") {
                    // If the parent is not in the hierarchy yet, add an empty array
                    if (!this.categoryHierarchy.has(category.parent)) {
                      this.categoryHierarchy.set(category.parent, []);
                    }

                    // Push the current category's ID to its parent's list
                    const parent = this.categoryHierarchy.get(category.parent);
                    if (parent) {
                      parent.push(category.id);
                    }
                  }
                });
              }
              this.categoriesMarkersDone = true; 
              console.log("--------spura   narejebi category markerji")
              await this.createCategoriesMarkers();
          },
        async createCategoriesMarkers() {
            let _this = this;
            let prevKey = ''; 
            let color:any = '';
            let promises: Promise<any>[] = [];
            let categoryHierarchy = this.categoryHierarchy;
            let poiCategories = this.poiCategories;
            
            for (let [mainCategoryId] of categoryHierarchy.entries()) {
                if(mainCategoryId != prevKey) {
                  prevKey = mainCategoryId;
                  if (poiCategories && poiCategories.get(mainCategoryId)) {
                      let category:any = poiCategories.get(mainCategoryId);
                      if (category && category.hasOwnProperty('cssColor')) {
                          color = category.cssColor;
                      }
                  }
                }
      
                this.countCategoriesMarkers = 0;

                for (let [key, value] of poiCategories.entries()) {

                  //kadar bodo kategorije ok odkomentiraj
                    if(value.parentId != mainCategoryId || value.isParent == true) {
                        continue;
                    }
                    let promise = new Promise((resolve) => {
                      
                    let colorStart = getComputedStyle(document.body).getPropertyValue(color+'-start');
                    let colorEnd = getComputedStyle(document.body).getPropertyValue(color+'-stop');
                          
                    let categoryIconName = mainCategoryId + '-' + key;
                    let markerKey =  'marker-categories-'+ window.devicePixelRatio +'-'+ encodeURIComponent(value.icon)+'-'+ colorStart + colorEnd; 
                    let saved = idb.getData(markerKey);
                    saved.then((imgdata:any) => {
                    if(imgdata == null) {


                    let node = document.createElement('div');
    
                    node.innerHTML = `
                    <svg width="88" height="114" viewBox="0 0 30 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_i_2258_58156)">
                    <path d="M3.33013 24.5019C-1.48835 18.516 -1.02967 9.84783 4.39343 4.40735C10.2512 -1.46919 19.7487 -1.46908 25.6064 4.40746C31.0295 9.84788 31.4884 18.516 26.6702 24.502L15.7797 38.0322C15.3794 38.5295 14.622 38.5295 14.2217 38.0323L3.33013 24.5019Z" fill="url(#paint0_linear_2258_58156)"/>
                    </g>
                    <image x="5" y="5" width="20" height="20" xlink:href="${value.icon}" />
    
                    <defs>
                    <filter id="filter0_i_2258_58156" x="0" y="0" width="30" height="38.4062" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="2.5"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2258_58156"/>
                    </filter>
                    <linearGradient id="paint0_linear_2258_58156" x1="15" y1="0" x2="15" y2="39" gradientUnits="userSpaceOnUse">
                    <stop stop-color="${colorStart}"/>
                    <stop offset="1" stop-color="${colorEnd}"/>
                    </linearGradient>
                    </defs>
                    </svg>
                    `;
                    //console.log("before toPng");
                    try {
                      toPng(node,{ width: 88, height: 114 })
                      .then(function (dataUrl) {
                        _this.categoryMarkersLook.set(categoryIconName, dataUrl);
                        idb.saveData(dataUrl, markerKey);
                          _this.countCategoriesMarkers++;
                          resolve(true);
                      })
                      .catch(function (error) {
                        //reject(error);
                        console.log("node error",node);
                        resolve(true);
                        console.error('oops, something went wrong! ', error);
                        console.log("something wrong on marker id:",key )
                      });

                  } catch (error) {
                    resolve(true);
                      console.error('oops, something went wrong!', error);
                  }
                }else{
                  _this.categoryMarkersLook.set(categoryIconName, imgdata);
                  _this.countCategoriesMarkers++;
                  resolve(true);           
                }
              })
                });
 
                promises.push(promise);
                }
            }

            try {
                await Promise.all(promises);
                console.log("its done");
                this.categoriesMarkersDone = true;
            } catch (error) {
                console.error('An error occurred:', error);
            }
        },
          returnCategoryIcon(category: string) {
            return this.poiCategories.get(category)?.icon;
          },
          
          //drejc tke naprej dodane
          getPoiImages: () => (size: string, data: any,destinationId: string) => {
            //const destinationId = state.closestDestinationId;
            const publicUrl = import.meta.env.VITE_MIZA_REPO_URL;

            console.log('getPoiImages', data);
            if (data.presentation === null) {
              return false;
            }
            /*
            try{
              presentation = JSON.parse(data.properties.presentation)
            }catch{
              return false;
            }
            */
            const presentation = data.presentation;
          
            if (presentation.basic==undefined || presentation.basic.content==undefined 
                || presentation.basic.content.gallery==undefined || presentation.basic.content.gallery.files==undefined 
                 || !Array.isArray(presentation.basic.content.gallery.files)  || presentation.basic.content.gallery.files.length == 0) {
              return false;
            }
          
          
            // Create image URLs
            let images = [];

            for (const slide of presentation.basic.content.gallery.files){
              images.push(`${publicUrl}${destinationId}/${slide.hash}-${size}.${slide.ext}`)
            }

        
            return images;
          },
          // drehc, ta ne dela
          getMarkerVideos: () => (data: any,destinationId: string) => {
            //const destinationId = state.closestDestinationId;
            const publicUrl = import.meta.env.VITE_PUBLIC_URL;
            //if (!state.markerThumbnails.has(id) || state.markerThumbnails.get(id) === null || markers === null || (markers as { [key: string]: any })[id] === null) {
              //check if marker has properties.presentation.basic.content.video
              if (data.properties.presentation === null) {
                return false;
              }
            
              const basic = data.properties.presentation.basic;
              if (basic === '') {
                return false;
              }
              
              // Check if basic content has video
              if (!basic.content.hasOwnProperty('video')) {
                return false;
              }
            
              // Check if video has files
              if (basic.content.video.files.length === 0) {
                return false;
              }
              
              // Create image URLs
              const images = basic.content.video.files.map((video: any) => {
                return `${publicUrl}repo/${destinationId}/${video.hash}.mp4`;
              });
            
              return images;
            //}
          },
        async loadDestinationOptions(destinationId: string) {
            try {
                const optionsUrl = import.meta.env.VITE_DESTINATION_DATA_URL + destinationId + '/options.json';
                const result = await readJSON(optionsUrl);
                if (result) {
                    const options = JSON.parse(result);
                    this.options = options;
                    const availableLanguages = options.destination?.languages || [];
                    this.allLanguages = availableLanguages;
                    // If current language is not in available languages, set to first available
                    if (!availableLanguages.includes(this.selectedLanguage)) {
                        this.selectedLanguage = availableLanguages[0] || 'sl';
                    }
                }
            } catch (error) {
                console.error('Error loading destination options:', error);
            }
        },
    },
    getters: {
      /*returnCategoryIcon: (state) => (category: string) => {
          return state.poiCategories.get(category)?.icon;
        },*/
        returnGradientColor: (state) => (category: string) => {
          let object = state.poiCategories.get(category);
          if(object && object.cssColor) {
            let color = document.documentElement.style.getPropertyValue(object.cssColor);
            return color;
          }
        },
        returnStartStopColor: (state) => (category: string) => {
          let object = state.poiCategories.get(category);
          if(object && object.cssColor) {
            let colorStart = document.documentElement.style.getPropertyValue(object.cssColor + '-start');
            let colorStop = document.documentElement.style.getPropertyValue(object.cssColor + '-stop');
            return [colorStart,colorStop];
          }
        },
        /*returnImage(id) {
          let pois:any = this.itinerary[this.selectedPath].pois;
          const images = useMarkersStore().getMarkerImage(id, 'm');
          let image = undefined;
          
          image = images[0];
          
          if (!image && markers.value[id] != undefined) {
            let category = markers.value[id].properties.categories[0];
            switch (category) {
              case 80:
                image = missingImageNature;
                break;
              case 81:
                image = missingImageSport;
                break;
              case 82:
                image = missingImageCulture;
                break;
              case 83:
                image = missingImageTourism;
                break;
              default:
                image = missingImageCulture;
                break;
            }
          } else if (image == undefined || markers.value[id] == undefined) {
          
            if (markers.value[id] == undefined) {
              console.log("markers is undefined, id: ", id);
            } else if (image == undefined) {
              console.log("image is undefined, id: ", markers.value[id].properties);
            } else {
              console.log("something else is wrong", id);
            }
          }
          
          return image;
          }*/
  }
});